var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 5.00008C3.33331 4.53984 3.70641 4.16675 4.16665 4.16675H15.8333C16.2936 4.16675 16.6666 4.53984 16.6666 5.00008C16.6666 5.46032 16.2936 5.83341 15.8333 5.83341H4.16665C3.70641 5.83341 3.33331 5.46032 3.33331 5.00008Z",
    fill: "#667185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 10.0001C4.99998 9.53984 5.37308 9.16675 5.83331 9.16675H14.1666C14.6269 9.16675 15 9.53984 15 10.0001C15 10.4603 14.6269 10.8334 14.1666 10.8334H5.83331C5.37308 10.8334 4.99998 10.4603 4.99998 10.0001Z",
    fill: "#667185"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 14.1667C7.03974 14.1667 6.66665 14.5398 6.66665 15.0001C6.66665 15.4603 7.03974 15.8334 7.49998 15.8334H12.5C12.9602 15.8334 13.3333 15.4603 13.3333 15.0001C13.3333 14.5398 12.9602 14.1667 12.5 14.1667H7.49998Z",
    fill: "#667185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContain);
export default __webpack_public_path__ + "static/media/contain.70bd83de08112a9653e8b04f4b4a4cb4.svg";
export { ForwardRef as ReactComponent };